import ConfiguredPercentage from './ConfiguredPercentage'

export default ConfiguredPercentage
